import { render, staticRenderFns } from "./website-footer.vue?vue&type=template&id=02dc7344&scoped=true"
import script from "./website-footer.vue?vue&type=script&lang=js"
export * from "./website-footer.vue?vue&type=script&lang=js"
import style0 from "./website-footer.vue?vue&type=style&index=0&id=02dc7344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dc7344",
  null
  
)

export default component.exports